const popularMarketTypes = ['1X2'];
const customBetMarket = ['Byg væddemål'];

const mostPopularMarkerFilter = (market) => {
    return (
        (market.popular > 0 &&
            !customBetMarket.includes(market.marketTypeGroupName)) ||
        (popularMarketTypes.includes(market.marketTypeGroupName) &&
            !customBetMarket.includes(market.marketTypeGroupName)) ||
        (market.itemList.some((bet) => bet.popular > 0) &&
            !customBetMarket.includes(market.marketTypeGroupName))
    );
};

const getMarketList = (event) => {
    if (!event || !Array.isArray(event.marketList)) {
        return [];
    }

    return event.marketList.map((marketItem) => {
        return {
            ...marketItem,
            itemList: marketItem.itemList.some(
                ({ popular }) => typeof popular === 'number' && popular > 0
            )
                ? marketItem.itemList.filter(({ popular }) => popular > 0)
                : marketItem.itemList,
        };
    });
};

export const getPopularMarkets = (event) => {
    const sortedByPopular = getMarketList(event)
        .filter(mostPopularMarkerFilter)
        .sort((a, b) => a.marketTypePriority - b.marketTypePriority);
    return sortedByPopular;
};
